import * as baseAdapter from './baseAdapter';
import {
  ICndnFreeForm,
  ISearchCndnFreeFormReq,
  ISearchCndnFreeFormRes,
} from '@/interfaces/cndnFreeForm';

export const searchCndnManual = async (req: ISearchCndnFreeFormReq) => {
  const ret = await baseAdapter.post<ISearchCndnFreeFormRes>(
    '/manualCreditDebitNote/gets',
    req,
  );
  return ret;
};

export const addCndnManual = async (data: Partial<ICndnFreeForm>) => {
  const ret = await baseAdapter.post<ICndnFreeForm>(
    '/manualCreditDebitNote/create',
    data,
  );
  return ret;
};

export const getCndnManual = async (id: number) => {
  const ret = await baseAdapter.get<ICndnFreeForm>(
    '/manualCreditDebitNote/get/' + id,
  );
  return ret?.data;
};

export const deleteCndnManual = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(
    `/manualCreditDebitNote/delete/${id}`,
  );
  return ret;
};
